export const FALLBACK_BOB_VERSION = '0.40.13';
export const FALLBACK_NITRO_MODULES_VERSION = '0.29.8';
export const SUPPORTED_REACT_NATIVE_VERSION = '0.81.1';
